<template>
  <Card class="publish-cta">
    <div class="publish-cta__description">
      <span>You can edit details anytime after publishing</span>
    </div>
    <div class="publish-cta__content">
      <h1>Your itinerary is ready to share</h1>
      <div class="publish-cta__checkbox">
        <SquareCheck :checked="isChecked" required @click="isChecked = !isChecked" />
        <span
          >I have read and agree to the
          <router-link :to="termsConditionsRoute" class="publish-cta__link"
            >Trip Terms & Conditions (including cancellation policy)</router-link
          >
          and
          <a href="/en/terms" class="publish-cta__link">TourHero Terms of Use.</a></span
        >
      </div>
      <Button :disabled="!isChecked" color="red" type="button" @click="publish" class="publish-cta__button"
        >Launch your itinerary</Button
      >
    </div>
  </Card>
</template>

<script setup lang="ts">
import { ref, watchEffect, computed } from 'vue'
import Button from '@/components/Theme2/Button.vue'
import Card from '@/components/Theme2/Card.vue'
import SquareCheck from 'app/javascript/src/components/Theme/SquareCheck.vue'
import { useTypedItineraryStore } from 'app/javascript/src/stores/typed'
import { Product } from 'app/javascript/src/models'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()
const store = useTypedItineraryStore<Product>()
const isChecked = ref(false)

const termsConditionsRoute = computed(() => {
  return {
    name: 'product-terms-conditions',
    params: route.params,
  }
})

watchEffect(() => {
  if (store.data?.state === 'published') {
    router.replace({
      name: 'product-launched',
      params: { country: store.data.destinationCountryName, id: store.data.id },
    })
  }
})

const publish = async () => {
  if (!isChecked.value || !store.data?.id) {
    return
  }

  try {
    await store.publishProduct(store.data.id)
    router.replace({
      name: 'product-launched',
      params: { country: store.data.destinationCountryName, id: store.data.id },
    })
  } catch (error) {
    console.error(error)
  }
}
</script>

<style lang="scss" scoped>
.publish-cta {
  &.card:has(.publish-cta__description) {
    padding: 0;
    gap: 0;
  }

  .publish-cta__description {
    color: $green-500;
    font-size: $text-sm;
    font-weight: $font-medium;
    background-color: $green-50;
    border-inline: 1px solid $green-100;
    border-top: 1px solid $green-100;
    border-radius: $rounded-xl $rounded-xl 0 0;
    padding: $spacing-3 $spacing-3 $spacing-5;
    text-align: center;
  }

  .publish-cta__content {
    margin-top: -$spacing-2;
    @include flex-column($spacing-4);
    align-items: center;
    padding: $spacing-8;
    border: 1px solid $grey-25;
    border-radius: $rounded-xl;
    background-color: $white;

    h1 {
      font-size: $text-xl;
      margin: 0;
      text-align: center;
    }

    .publish-cta__checkbox {
      display: flex;
      align-items: flex-start;
      gap: $spacing-2;

      .publish-cta__link {
        color: $brand-tertiary;
      }
    }
  }
}
</style>
